'use client';

import React, { useEffect, useState, useCallback, useRef } from 'react';
import { X, ChevronLeft, Loader2, XCircle, ClipboardCheck, Info, ArrowRight, Smartphone } from 'lucide-react';
import dynamic from 'next/dynamic';
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });
import MethodCards from './MethodCards';
import ProviderSelection, { CryptoProvider } from './ProviderSelection';
import { useAppAuth } from '@/hooks/useAppAuth';
import axios from 'axios';
import { API_URL } from '@/lib/api-config';

type PaymentMethodType = 'CARD' | 'QR' | 'CRYPTO' | 'EZCASH';

interface PaymentModalProps {
  show: boolean;
  baseAmount: number;
  charges?: { processingChargeEnabled: boolean; processingChargePercent: number };
  selectedPaymentMethod: string | null;
  setSelectedPaymentMethod: (v: string | null) => void;
  isSubmittingOrder: boolean;
  paymentConfig?: any;
  onClose: () => void;
  onGenieCheckout: (mode: 'CARD' | 'QR') => void;
  onCeypayCheckout?: (provider: CryptoProvider) => void;
  onBcoinCheckout?: () => void;
  onEzCashCheckout?: (referenceNumber: string) => Promise<any>;
}

export default function PaymentModal({
  show,
  baseAmount,
  charges,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  isSubmittingOrder,
  onClose,
  onGenieCheckout,
  onCeypayCheckout,
  onBcoinCheckout,
  onEzCashCheckout,
}: PaymentModalProps) {

  const SHOW_BCOINS = true;

  const successAnimation = {
  "v": "5.7.12",
  "fr": 24,
  "ip": 0,
  "op": 72,
  "w": 520,
  "h": 520,
  "nm": "Checklist 2",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Checklist",
      "sr": 1,
      "ks": {
        "o": { "a": 1, "k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 50, "s": [100]}, {"t": 62, "s": [0]}], "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [259.587, 260.119, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [297.587, 298.119, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            { "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [0, 0], [0, 0]], "o": [[0, 0], [0, 0], [0, 0]], "v": [[54.754, -36.121], [-17.487, 36.12], [-54.754, -1.147]], "c": false }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false },
            { "ty": "st", "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 23, "ix": 5 }, "lc": 2, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false },
            { "ty": "tr", "p": { "a": 0, "k": [294.971, 298.679], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        { "ty": "tm", "s": { "a": 1, "k": [{"i": {"x": [0], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 24, "s": [100]}, {"t": 36, "s": [0]}], "ix": 1 }, "e": { "a": 0, "k": 100, "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim", "hd": false }
      ],
      "ip": 0,
      "op": 720,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Cricle",
      "sr": 1,
      "ks": {
        "o": { "a": 1, "k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 50, "s": [100]}, {"t": 62, "s": [0]}], "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [260, 260, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-7.627, -7.691, 0], "ix": 1, "l": 2 },
        "s": { "a": 1, "k": [{"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]}, "o": {"x": [0.167, 0.167, 0.167], "y": [0, 0, 0]}, "t": 18, "s": [124.222, 124.222, 100]}, {"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]}, "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]}, "t": 20, "s": [134.222, 134.222, 100]}, {"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]}, "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]}, "t": 22, "s": [114.22200000000001, 114.22200000000001, 100]}, {"t": 24, "s": [124.222, 124.222, 100]}], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            { "d": 1, "ty": "el", "s": { "a": 0, "k": [178.46, 178.46], "ix": 2 }, "p": { "a": 0, "k": [0, 0], "ix": 3 }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse", "hd": false },
            { "ty": "tm", "s": { "a": 0, "k": 0, "ix": 1 }, "e": { "a": 1, "k": [{"i": {"x": [0.239], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 0, "s": [0]}, {"t": 24, "s": [100]}], "ix": 2 }, "o": { "a": 0, "k": 0, "ix": 3 }, "m": 1, "ix": 2, "nm": "Trim Paths 1", "mn": "ADBE Vector Filter - Trim", "hd": false },
            { "ty": "st", "c": { "a": 0, "k": [0.1843137254901961, 0.796078431372549, 0.5098039215686274, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 10, "ix": 5 }, "lc": 2, "lj": 2, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false },
            { "ty": "fl", "c": { "a": 0, "k": [0.1843137254901961, 0.796078431372549, 0.5098039215686274, 1], "ix": 4 }, "o": { "a": 1, "k": [{"i": {"x": [0], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 22, "s": [0]}, {"t": 24, "s": [100]}], "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false },
            { "ty": "tr", "p": { "a": 0, "k": [-7.627, -7.691], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }
          ],
          "nm": "Ellipse 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 720,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Shadow",
      "sr": 1,
      "ks": {
        "o": { "a": 1, "k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 22, "s": [0]}, {"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 33, "s": [100]}, {"t": 44, "s": [0]}], "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [260, 260, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [298, 298, 0], "ix": 1, "l": 2 },
        "s": { "a": 1, "k": [{"i": {"x": [0, 0, 0.667], "y": [1, 1, 1]}, "o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]}, "t": 22, "s": [60, 60, 100]}, {"t": 44, "s": [100, 100, 100]}], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            { "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[-94.797, 0], [0, -94.797], [94.797, 0], [0, 94.798]], "o": [[94.797, 0], [0, 94.798], [-94.797, 0], [0, -94.797]], "v": [[0, -171.646], [171.646, 0], [0, 171.646], [-171.646, 0]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false },
            { "ty": "fl", "c": { "a": 0, "k": [0.9529411764705882, 1, 0.984313725490196, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false },
            { "ty": "tr", "p": { "a": 0, "k": [297.587, 298.119], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 22,
      "op": 720,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
};

  const [lang, setLang] = useState<'sin' | 'eng' | 'tam'>('sin');
  const [selectedProvider, setSelectedProvider] = useState<CryptoProvider | null>(null);
  const [view, setView] = useState<'methods' | 'providers' | 'ezcash'>('methods');

  const auth = useAppAuth();
  const [bcoinBalance, setBcoinBalance] = useState<number | null>(null);

  const [ezcashRn, setEzcashRn] = useState('');
  const [isRedeeming, setIsRedeeming] = useState(false);
  const [ezcashResult, setEzcashResult] = useState<{
    success: boolean;
    paid: boolean;
    creditedToBalance: boolean;
    message: string;
    creditedAmount?: number;
    orderAmount?: number;
    shortfall?: number;
    id?: string;
    excessCredited?: number;
  } | null>(null);

  useEffect(() => {
    if (show && auth.isAuthenticated && SHOW_BCOINS) {
      auth.getToken().then((token) => {
        if (token) {
          axios
            .get(`${API_URL}/bcoins/balance`, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => setBcoinBalance(res.data?.data?.balance ?? 0))
            .catch((err) => console.error('Failed to fetch BCoins balance:', err));
        }
      });
    } else if (!show) {
      setBcoinBalance(null);
    }
  }, [show, auth.isAuthenticated]);

  useEffect(() => {
    if (show) {
      setSelectedPaymentMethod('CARD');
      setSelectedProvider(null);
      setView('methods');
      setEzcashRn('');
      setEzcashResult(null);
    }
  }, [show, setSelectedPaymentMethod]);

  const canClose = !isSubmittingOrder && !isRedeeming;
  const processingChargePercent =
    charges?.processingChargeEnabled && charges.processingChargePercent > 0
      ? charges.processingChargePercent
      : 0;
  const isEzCashSelected = SHOW_BCOINS && selectedPaymentMethod === 'EZCASH';
  const processingFeeAmount =
    !isEzCashSelected && processingChargePercent > 0
      ? Math.ceil((baseAmount * processingChargePercent) / 100)
      : 0;
  const payableAmount = baseAmount + processingFeeAmount;
  const isEzCashInsufficient = isEzCashSelected && bcoinBalance !== null && bcoinBalance < baseAmount;

  useEffect(() => {
    if (show && isEzCashInsufficient && view === 'methods') {
      setView('ezcash');
    }
  }, [show, isEzCashInsufficient, view]);

  if (!show) return null;

  const isEzCashSufficient = isEzCashSelected && bcoinBalance !== null && bcoinBalance >= baseAmount;

  const handleMethodSelect = (methodId: string) => {
    setSelectedPaymentMethod(methodId);
    setSelectedProvider(null);
    setEzcashRn('');
    setEzcashResult(null);
    if (methodId === 'CRYPTO') {
      setView('providers');
    } else if (methodId === 'EZCASH' && bcoinBalance !== null && bcoinBalance < baseAmount) {
      setView('ezcash');
    }
  };

  const handleBackToMethods = () => {
    setView('methods');
    setSelectedPaymentMethod('CARD');
    setSelectedProvider(null);
    setEzcashRn('');
    setEzcashResult(null);
  };

  const handleSubmit = () => {
    if (selectedPaymentMethod === 'CARD' || selectedPaymentMethod === 'QR') {
      onGenieCheckout(selectedPaymentMethod);
    } else if (selectedPaymentMethod === 'CRYPTO' && selectedProvider && onCeypayCheckout) {
      onCeypayCheckout(selectedProvider);
    } else if (SHOW_BCOINS && selectedPaymentMethod === 'EZCASH' && isEzCashSufficient && onBcoinCheckout) {
      onBcoinCheckout();
    }
  };

  const handleEzCashRedeem = async () => {
    if (ezcashRn.trim().length !== 14) return;
    setIsRedeeming(true);
    setEzcashResult(null);

    try {
      if (!onEzCashCheckout) return;
      const result = await onEzCashCheckout(ezcashRn.trim());
      setEzcashResult(result);

      // Refresh BCoins balance after any EzCash result
      if (result.creditedToBalance) {
        const token = await auth.getToken();
        if (token) {
          axios
            .get(`${API_URL}/bcoins/balance`, {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => setBcoinBalance(res.data?.data?.balance ?? 0))
            .catch(() => {});
        }
      }
    } catch (err: any) {
      const msg = err.response?.data?.message || err.message || 'Failed to process EzCash reference number';
      setEzcashResult({
        success: false,
        paid: false,
        creditedToBalance: false,
        message: msg,
      });
    } finally {
      setIsRedeeming(false);
    }
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      const digits = text.replace(/\D/g, '').slice(0, 14);
      setEzcashRn(digits);
    } catch (err) {
      console.error('Failed to read clipboard text:', err);
    }
  };

  const getWarningText = () => {
    if (lang === 'sin') return 'Pay Button එක Click කිරීමෙන් විනාඩි 5ක් ඇතුලත ගෙවීම සිදු කල යුතුය !!!';
    if (lang === 'eng') return 'Payment must be completed within 5 minutes of clicking the Pay Button !!!';
    if (lang === 'tam') return 'Pay Button ஐ கிளிக் செய்த 5 நிமிடங்களுக்குள் பணம் செலுத்தப்பட வேண்டும் !!!';
    return '';
  };

  const renderWarning = () => (
    <div className="relative bg-rose-50 border border-rose-100 rounded-xl p-3.5 pt-4">
      <div className="absolute -top-3 right-3 flex gap-1 bg-white p-1 rounded-md shadow-sm border border-slate-100">
        {(['sin', 'eng', 'tam'] as const).map((l) => (
          <button
            key={l}
            onClick={() => setLang(l)}
            className={`text-[9px] px-1.5 py-0.5 rounded transition-colors ${
              lang === l
                ? 'bg-rose-500 text-white font-medium'
                : 'hover:bg-slate-100 text-slate-500 font-normal'
            }`}
          >
            {l === 'sin' ? 'සිංහල' : l === 'eng' ? 'EN' : 'தமிழ்'}
          </button>
        ))}
      </div>
      <p className="text-xs font-semibold text-rose-600 mt-1 leading-relaxed">
        {getWarningText()}
      </p>
    </div>
  );

  const renderMethodSelection = () => {
    return (
    <>
      <div className="px-5 py-4 shrink-0 bg-slate-50/30">
        <MethodCards
          selected={selectedPaymentMethod}
          onSelect={handleMethodSelect}
          processingChargePercent={processingChargePercent}
          bcoinBalance={bcoinBalance}
        />
      </div>

      {(selectedPaymentMethod === 'CARD' || selectedPaymentMethod === 'QR' || (SHOW_BCOINS && selectedPaymentMethod === 'EZCASH')) && (
        <>
          <div className="flex-1 overflow-y-auto bg-white px-5 relative">
            <div className="py-5 space-y-4 pt-6">
              <AmountDisplay
                amount={payableAmount}
                processingFeeAmount={processingFeeAmount}
                isBcoinMethod={isEzCashSelected}
              />
              {selectedPaymentMethod === 'QR' && (
                <p className="text-xs text-slate-600 font-medium px-1">
                  LANKA QR - ඕනෑම Bank Acc එකකින් QR එක Scan කර ගෙවීම සිදු කල හැක.
                </p>
              )}
              {isEzCashSelected && isEzCashInsufficient && (
                <div className="bg-rose-50 text-rose-600 border border-rose-100 rounded-lg p-4 text-sm flex flex-col gap-3 items-center justify-center text-center">
                  <div>
                    <span className="font-semibold">Insufficient eZ Cash Balance</span>
                    <span className="text-xs opacity-80 block mt-1">You have {bcoinBalance} eZ Cash, but the order requires {payableAmount}.</span>
                  </div>
                  <button
                    onClick={() => setView('ezcash')}
                    className="inline-flex items-center gap-1.5 bg-amber-500 hover:bg-amber-600 text-white font-bold px-4 py-2 rounded-lg text-xs uppercase tracking-wider transition-all"
                  >
                    Verify with EzCash Reference Number
                  </button>
                </div>
              )}
              {!isEzCashSelected && renderWarning()}
            </div>
          </div>
          {(!isEzCashSelected || isEzCashSufficient) && (
            <Footer
              isSubmitting={isSubmittingOrder}
              isDisabled={isEzCashSelected && isEzCashInsufficient}
              label="PAY NOW"
              onSubmit={handleSubmit}
            />
          )}
        </>
      )}
    </>
    );
  };

  const renderEzCashView = () => {
    const isSuccess = ezcashResult?.paid === true;
    const isInsufficient = !ezcashResult?.paid && ezcashResult?.creditedToBalance === true;
    const isError = !!ezcashResult && !ezcashResult.paid && !ezcashResult.creditedToBalance;

    return (
      <>
        <div className="flex-1 overflow-y-auto bg-white px-5">
          <div className="py-5 space-y-4 pt-6">
            {!ezcashResult && (
              <div className="space-y-3">
                <div className="space-y-1">
                  <h3 className="text-xs font-bold uppercase tracking-wider text-foreground">
                    Send eZ Cash To
                  </h3>
                  <p className="text-[10px] text-muted-foreground">
                    Please send the exact order amount to the following number before verifying.
                  </p>
                </div>
                <div className="grid gap-2 grid-cols-1">
                  {[process.env.NEXT_PUBLIC_EZCASH_NUMBER || '0767564233'].map((num, idx) => (
                    <div key={idx} className="flex items-center justify-between p-3 rounded-xl border border-border bg-muted/20">
                      <div className="flex flex-col">
                        <span className="text-[9px] uppercase font-bold tracking-widest text-muted-foreground">{process.env.NEXT_PUBLIC_EZCASH_HOLDER || 'Baasil Topup'}</span>
                        <span className="text-sm font-bold font-mono tracking-wider mt-0.5 text-foreground">{num}</span>
                      </div>
                      <Smartphone className="w-4 h-4 text-primary/50" />
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="pt-6 pb-2">
              <AmountDisplay
                amount={payableAmount}
                processingFeeAmount={0}
                isBcoinMethod={false}
                label="Order Amount"
              />
            </div>
          </div>

          {!ezcashResult && (
            <div className="space-y-3 pb-6">
              <div className="space-y-1">
                <h3 className="text-xs font-bold uppercase tracking-wider text-slate-800">
                  Enter EzCash Reference Number
                </h3>
                <p className="text-[10px] text-slate-500">
                  Enter the 14-digit Reference Number (RN) from your Dialog eZ Cash SMS.
                </p>
              </div>

              <div className="relative">
                <input
                  type="text"
                  value={ezcashRn}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '');
                    if (val.length <= 14) setEzcashRn(val);
                  }}
                  placeholder="eZ Cash Reference Number"
                  className="w-full rounded-lg border border-slate-200 bg-slate-50/50 py-4 px-4 pl-12 text-sm text-slate-900 placeholder:text-slate-400 outline-none transition focus:border-[#5A98D8] focus:bg-white focus:ring-4 focus:ring-[#5A98D8]/10 shadow-inner"
                  disabled={isRedeeming}
                />
                <span className="absolute inset-y-0 left-4 flex items-center text-[#5A98D8] text-sm font-black">&gt;_</span>

                <button
                  onClick={handlePaste}
                  className="absolute inset-y-0 right-2 my-2 inline-flex items-center justify-center rounded-lg border border-slate-200 bg-white px-3 text-slate-500 hover:border-[#5A98D8]/45 hover:text-[#5A98D8] transition-all active:scale-95 shadow-sm"
                  disabled={isRedeeming}
                >
                  <ClipboardCheck className="w-3.5 h-3.5 mr-1 text-[#5A98D8]/80" />
                  <span className="text-[9px] font-bold uppercase tracking-widest">Paste</span>
                </button>
              </div>

              <div className="flex items-center justify-between text-[11px] text-slate-500 bg-slate-50 border border-slate-200/80 rounded-lg p-3">
                <span className="flex items-center gap-1.5">
                  <Info className="h-3.5 w-3.5 text-[#5A98D8] shrink-0" />
                  Enter the exact 14-digit RN from your eZ Cash SMS
                </span>
                <span className={`font-bold px-2 py-0.5 rounded-md ${ezcashRn.length === 14 ? 'bg-emerald-500/10 text-emerald-600 border border-emerald-500/20' : 'bg-slate-100 border border-slate-200 text-slate-500'}`}>
                  {ezcashRn.length} / 14
                </span>
              </div>

              <button
                onClick={handleEzCashRedeem}
                disabled={isRedeeming || ezcashRn.length !== 14}
                className="w-full inline-flex items-center justify-center gap-2.5 rounded-lg bg-[#5A98D8] hover:bg-[#4A88C8] text-white px-5 py-4 text-xs font-bold uppercase tracking-[0.2em] transition-all disabled:bg-slate-300 disabled:text-slate-500 disabled:cursor-not-allowed shadow-sm active:scale-[0.99]"
              >
                {isRedeeming ? (
                  <>
                    <Loader2 className="w-3.5 h-3.5 animate-spin" />
                    Verifying Reference Number...
                  </>
                ) : (
                  <>
                    <ArrowRight className="w-3.5 h-3.5" />
                    Verify & Pay
                  </>
                )}
              </button>
            </div>
          )}

          {isSuccess && <SuccessOverlay orderId={ezcashResult.id} onClose={onClose} animationData={successAnimation} />}

          {isInsufficient && (
            <div className="rounded-xl border border-amber-500/20 bg-amber-500/5 p-4 flex items-start gap-3.5 mb-4">
              <Info className="mt-0.5 h-5 w-5 shrink-0 text-amber-500" />
              <div className="min-w-0 flex-1">
                <h5 className="text-sm font-bold uppercase tracking-[0.08em] text-amber-600">
                  Amount Credited to Your Account
                </h5>
                <p className="mt-1 text-xs text-slate-600 leading-relaxed">
                  Your EzCash RN of <strong>Rs.{ezcashResult.creditedAmount?.toLocaleString()}</strong> has been credited.
                </p>
                <div className="mt-2 inline-flex items-center gap-1.5 rounded-full border border-amber-500/25 bg-amber-500/10 px-3 py-1 text-[11px] font-bold text-amber-600">
                  +{ezcashResult.creditedAmount?.toLocaleString()} eZ Cash Added
                </div>
                {ezcashResult.shortfall && ezcashResult.shortfall > 0 && (
                  <div className="mt-3 p-3 rounded-lg border border-red-200 bg-red-50">
                    <p className="text-xs font-bold text-red-700 uppercase tracking-wider">
                      Still Short by Rs.{ezcashResult.shortfall.toLocaleString()}
                    </p>
                    <p className="mt-1 text-xs text-red-600">
                      Your current balance <strong>(Rs.{bcoinBalance?.toLocaleString() || '0'})</strong> is not enough for this order <strong>(Rs.{ezcashResult.orderAmount?.toLocaleString()})</strong>.
                    </p>
                    <p className="mt-1 text-xs text-red-600">
                      Enter another RN to make up the difference, or choose a different payment method.
                    </p>
                  </div>
                )}
                {bcoinBalance !== null && ezcashResult.orderAmount && bcoinBalance >= ezcashResult.orderAmount && (
                  <div className="mt-3">
                    <button
                      onClick={onBcoinCheckout}
                      disabled={isSubmittingOrder}
                      className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 px-4 text-xs uppercase tracking-wider transition-all disabled:bg-slate-300"
                    >
                      {isSubmittingOrder ? (
                        <><Loader2 className="w-3.5 h-3.5 animate-spin" /> Processing...</>
                      ) : (
                        <>Pay Now with eZ Cash Balance (Rs.{bcoinBalance.toLocaleString()})</>
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}

          {isError && (
            <div className="rounded-xl border border-red-500/20 bg-red-500/5 p-4 flex items-start gap-3.5">
              <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-500" />
              <div className="min-w-0 flex-1">
                <h5 className="text-sm font-bold uppercase tracking-[0.08em] text-red-600">
                  Payment Failed
                </h5>
                <p className="mt-1 text-xs text-slate-600 leading-relaxed">
                  {ezcashResult?.message}
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="p-4 border-t border-slate-200 bg-white shrink-0 shadow-[0_-4px_10px_rgba(0,0,0,0.02)] z-10">
          {!ezcashResult ? (
            <p className="text-[10px] text-center text-slate-500">
              Enter the 14-digit RN from your eZ Cash SMS to proceed
            </p>
          ) : isSuccess ? null : (
            <div className="flex gap-2">
              <button
                onClick={() => {
                  setEzcashRn('');
                  setEzcashResult(null);
                }}
                className="flex-1 bg-[#5A98D8] hover:bg-[#4A88C8] text-white font-bold py-3.5 rounded-xl transition-all shadow-lg active:scale-[0.98] uppercase tracking-wider text-xs"
              >
                Try Another RN
              </button>
              <button
                onClick={handleBackToMethods}
                className="flex-1 border border-slate-200 bg-white hover:bg-slate-50 text-slate-800 font-bold py-3.5 rounded-xl transition-all active:scale-[0.98] uppercase tracking-wider text-xs"
              >
                Choose Different Method
              </button>
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={() => canClose && onClose()}
      />

      <div className="relative w-full max-w-[420px] bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-200 flex flex-col max-h-[90vh]">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-100 bg-slate-50/50 shrink-0">
          <div className="flex items-center gap-3">
            {view === 'providers' || view === 'ezcash' ? (
              <button
                onClick={handleBackToMethods}
                className="text-slate-400 hover:text-slate-700 bg-white hover:bg-slate-100 rounded-full w-7 h-7 flex items-center justify-center transition-colors shadow-sm border border-slate-200"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
            ) : null}
            <h2 className="text-[28px] md:text-[32px] font-display uppercase leading-[1] flex items-center" style={{ color: '#343434', letterSpacing: '0.01em' }}>
              {view === 'providers' ? (
                <span>Crypto <span style={{ color: '#5A98D8' }}>Providers</span></span>
              ) : view === 'ezcash' ? (
                <span>EzCash <span style={{ color: '#5A98D8' }}>Verify</span></span>
              ) : (
                <span>Select Payment <span style={{ color: '#5A98D8' }}>Method</span></span>
              )}
              <span className="text-xl ml-3 -mt-1 opacity-80">🔒</span>
            </h2>
          </div>
          <button
            onClick={() => canClose && onClose()}
            className="text-slate-400 hover:text-slate-700 bg-white hover:bg-slate-100 rounded-full w-8 h-8 flex items-center justify-center transition-colors shadow-sm border border-slate-200"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Content */}
        <div className="relative overflow-hidden flex-1 flex flex-col">
          <div className={`transition-all duration-300 ease-in-out flex-1 flex flex-col h-full overflow-hidden ${
            view === 'providers' || view === 'ezcash'
              ? '-translate-x-full absolute inset-0 pointer-events-none'
              : 'translate-x-0 relative'
          }`}>
            {renderMethodSelection()}
          </div>

          <div className={`transition-all duration-300 ease-in-out flex-1 flex flex-col h-full overflow-hidden ${
            view === 'providers'
              ? 'translate-x-0 relative'
              : 'translate-x-full absolute inset-0 pointer-events-none'
          }`}>
            <ProviderSelection
              baseAmount={payableAmount}
              selectedProvider={selectedProvider}
              isSubmittingOrder={isSubmittingOrder}
              onSelectProvider={setSelectedProvider}
              onSubmit={handleSubmit}
              renderWarning={renderWarning}
            />
          </div>

          <div className={`transition-all duration-300 ease-in-out flex-1 flex flex-col h-full overflow-hidden ${
            view === 'ezcash'
              ? 'translate-x-0 relative'
              : 'translate-x-full absolute inset-0 pointer-events-none'
          }`}>
            {renderEzCashView()}
          </div>
        </div>
      </div>
    </div>
  );
}

function SuccessOverlay({ orderId, onClose, animationData }: { orderId?: string; onClose: () => void; animationData: any }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
      if (orderId) {
        window.location.href = `/payment-status?id=${encodeURIComponent(orderId)}`;
      } else {
        onClose();
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [orderId, onClose]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[300] flex flex-col items-center justify-center bg-white/95 backdrop-blur-sm">
      <div className="w-48 h-48 md:w-56 md:h-56 mt-12">
        <Lottie animationData={animationData} loop={false} />
      </div>
      <p className="mt-4 text-sm font-semibold text-emerald-600">
        Payment Successful!
      </p>
      <p className="mt-1 text-xs text-slate-500">
        Redirecting to payment status...
      </p>
    </div>
  );
}

function AmountDisplay({
  amount,
  processingFeeAmount,
  isBcoinMethod,
  label,
}: {
  amount: number;
  processingFeeAmount: number;
  isBcoinMethod: boolean;
  label?: string;
}) {
  return (
    <div className="bg-slate-50 rounded-xl p-3 -mt-6 border border-slate-200 shadow-sm flex flex-col items-center justify-center text-center">
      <div className="flex flex-col items-center">
        <div className="text-[10px] md:text-[9px] font-bold uppercase tracking-[0.1em]" style={{ color: '#8BA3C0' }}>
          {label || 'Amount to Pay'}
        </div>
        <div className="text-[36px] md:text-[46px] leading-[1] font-display text-slate-800 mt-2 flex items-baseline justify-center gap-1.5">
          <span className="text-lg text-slate-400 font-bold">Rs.</span>
          {amount.toFixed(2)}
        </div>
        {/* processing fee text removed from UI */}
      </div>
    </div>
  );
}

function Footer({
  isSubmitting,
  isDisabled,
  label,
  onSubmit,
}: {
  isSubmitting: boolean;
  isDisabled: boolean;
  label: string;
  onSubmit: () => void;
}) {
  return (
    <div className="p-4 border-t border-slate-200 bg-white shrink-0 shadow-[0_-4px_10px_rgba(0,0,0,0.02)] z-10">
      <button
        onClick={onSubmit}
        disabled={isDisabled || isSubmitting}
        className="w-full bg-slate-900 disabled:bg-slate-300 disabled:cursor-not-allowed hover:bg-slate-800 text-white font-bold py-4 rounded-sm transition-all shadow-lg active:scale-[0.98] uppercase tracking-wider text-sm flex items-center justify-center gap-2"
      >
        {isSubmitting ? (
          <><LoaderIcon /> Processing...</>
        ) : (
          <>{label}<ForwardIcon /></>
        )}
      </button>
    </div>
  );
}

function LoaderIcon() {
  return (
    <svg className="w-5 h-5 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
  );
}

function ForwardIcon() {
  return (
    <svg className="w-4 h-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  );
}
